import { lazy } from 'react'

const HomePage = lazy(() => import('src/pages/HomePage'))
const NoMatchPage = lazy(() => import('src/pages/NoMatch'))
const FeaturePage = lazy(() => import('src/pages/FeaturePage'))
const MerchantPage = lazy(() => import('src/pages/MerchantPage'))
const DownloadPage = lazy(() => import('src/pages/DownloadPage'))
const ContactUsPage = lazy(() => import('src/pages/ContactUsPage'))

const RegisterSuccessPage = lazy(
  () => import('src/pages/RegistrationSuccessPage')
)

export const NAVIGATION_ROUTES = Object.freeze({
  home: {
    path: '/',
    exact: true,
    element: <HomePage />
  },
  feature: {
    path: '/feature',
    element: <FeaturePage />
  },
  merchant: {
    path: '/merchant',
    element: <MerchantPage />
  },
  RegisterSuccess: {
    path: '/register',
    search: '?success=true',
    element: <RegisterSuccessPage />
  },
  noMatch: {
    path: '*',
    element: <NoMatchPage />
  },
  Download: {
    path: '/download',
    element: <DownloadPage />
  },
  ContactUs: {
    path: '/contact-us',
    element: <ContactUsPage />
  }
})
